<template>
  <div
    v-if="showLoadingState || $store.getters.getAcademyLoadingSubmenu"
    key="loadingState"
  >
    <AtomLoadingSecondary/>
  </div>
  <div v-else>
    <div
      key="academyUserProfile"
      class="m-edition-academy-users-profile"
    >
      <div class="display-flex-row space-between">
        <div class="m-card-primary profile-info">
          <div class="display-flex-row-center profile-info-user-profile-sales">
            <AtomAvatarSecondary
              avatar-class="xlarge profile-info-user-avatar"
              :user-image="perfil.usuario.avatar"
            />
            <span class="display-flex-column font-weight-light justify-content-center">
              <span
                v-if="perfil.usuario.persona && perfil.usuario.persona.razon_social"
                class="font-size-large"
              >
                <b>{{ perfil.usuario.persona.razon_social }}</b>
              </span>
              <span :class="getUserGlobalState()">
                {{ perfil.usuario.email }}
              </span>
            </span>
          </div>
        </div>
        <div class="float-right">
          <AtomInputPrimary
            v-model="search"
            placeholder='Buscar'
            name="search"
            type="text"
            @input="searchProyectos"
          />
        </div>
      </div>
    <div
      v-if="showLoadingState2"
      key="loadingState"
    >
      <AtomLoadingSecondary/>
    </div>
    <div v-else>
      <div
        v-if="!search"
        class="m-edition-academy-users-profile-assets margin-bottom-xxlarge"
      >
        <a
          v-for="proyecto in proyectos"
          :key="proyecto.id"
          class="m-edition-academy-users-profile-assets-included"
          href="#"
          @click.prevent="updateProductoProyectos('addOne', proyecto)"
        >
          <div
            v-if="!proyecto.inscripcion_activa"
            class="action action-add"
          >
            {{ $t('mEditionAcademyUsersProfileMaps.actions.add') }}
          </div>
          <div
            v-else
            class="action action-remove"
          >
            {{ $t('mEditionAcademyUsersProfileAssets.actions.remove') }}
          </div>
          <MoleculeFeedSectionContentCardDesign2
            :class="!proyecto.inscripcion_activa ? 'not-included' : ''"
            :element="proyecto"
            :hide-move-icon="true"
            :is-asset-included="!proyecto.inscripcion_activa ? false : true"
            :is-asset-included-edition="true"
            :is-asset-included-request-loading="requests.updateProductoProyectos.isRequested &&
            requests.updateProductoProyectos.itemLoading === proyecto.id_proyecto"
          />
        </a>
      </div>
      <div
        v-else
        class="m-edition-academy-users-profile-assets margin-bottom-xxlarge"
      >
        <a
          v-for="proyecto in searcheds"
          :key="proyecto.id"
          class="m-edition-academy-users-profile-assets-included"
          href="#"
          @click.prevent="updateProductoProyectos('addOne', proyecto)"
        >
          <div
            v-if="!proyecto.inscripcion_activa"
            class="action action-add"
          >
            {{ $t('mEditionAcademyUsersProfileMaps.actions.add') }}
          </div>
          <div
            v-else
            class="action action-remove"
          >
            {{ $t('mEditionAcademyUsersProfileAssets.actions.remove') }}
          </div>
          <MoleculeFeedSectionContentCardDesign2
            :class="!proyecto.inscripcion_activa ? 'not-included' : ''"
            :element="proyecto"
            :hide-move-icon="true"
            :is-asset-included="!proyecto.inscripcion_activa ? false : true"
            :is-asset-included-edition="true"
            :is-asset-included-request-loading="requests.updateProductoProyectos.isRequested &&
            requests.updateProductoProyectos.itemLoading === proyecto.id_proyecto"
          />
        </a>
      </div>
     </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyUsersProfileMaps',

  components: {
    MoleculeFeedSectionContentCardDesign2: () => import('@/components/molecules/MoleculeFeedSectionContentCardDesign2')
  },

  data () {
    return {
      filter: {
        'tipo': 1
      },

      perfil: {},
      proyectos: [],

      requests: {
        updateProductoProyectos: {
          itemLoading: '',
          isRequested: false
        }
      },

      search: '',
      searcheds: [],
      showLoadingState: true,
      showLoadingState2: true
    }
  },

  created () {
    this.readAcademiaPerfilActor()
  },

  methods: {
    getUserGlobalState () {
      if (this.perfil.actores.find(actor => actor.habilitado === 1)) {
        return 'font-weight-bold text-color-success'
      } else {
        return 'font-weight-bold text-color-danger'
      }
    },

    readAcademiaPerfilActor () {
      this.$services.read('academia', 'readAcademiaPerfilActor', {}, [this.$store.getters.getAcademyData.id, this.$route.params.id])
        .then(response => {
          this.perfil = Object.assign({}, response.data)
          this.perfil.actores.sort((a, b) => {
            return Date.parse(a.fecha_alta) - Date.parse(b.fecha_alta)
          })
          this.readProyectos()
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState = false
        })
    },

    readProyectos () {
      this.$services.read('academia', 'readProyectosAcademia', {}, [this.$store.getters.getAcademyData.id, this.perfil.actores.find(a => { return a.tipo === 0 }).id], this.filter)
        .then(response => {
          this.proyectos = [...response.data]
          this.showLoadingState = false
          this.showLoadingState2 = false
          this.requests.updateProductoProyectos.isRequested = false
        })
        .catch(error => {
          console.log(error)
        })
    },

    searchProyectos () {
      if (!this.showLoadingState2) {
        if (this.search) {
          this.searcheds = this.proyectos.filter(e => e.titulo.toLowerCase().match(this.search.toLowerCase()))
        } else {
          this.proyectos = []
          this.showLoadingState2 = true
          this.readProyectos()
        }
      }
    },

    updateProductoProyectos (action, proyecto) {
      if (!this.requests.updateProductoProyectos.isRequested) {
        this.requests.updateProductoProyectos.isRequested = true
        this.requests.updateProductoProyectos.itemLoading = proyecto && proyecto.id_proyecto ? proyecto.id_proyecto : action

        if (proyecto.id_inscripcion === undefined) {
          this.$services.create('inscripcion', 'createInscripcionManual', { proyecto: proyecto.id_proyecto, email: [this.perfil.usuario.email] }, [this.$store.getters.getAcademyData.id])
            .then(response => {
              this.$alerts.pushAlert('mEditionAcademyUsersProfileAssets', 'createInscripcion', 'success')
              this.search = ''
              this.searcheds = []
              this.readProyectos()
            })
            .catch(error => {
              console.log(error)
              this.$alerts.pushAlert('mEditionAcademyUsersProfileAssets', 'createInscripcion', 'error', 'a-alert-danger')
              this.requests.updateProductoProyectos.isRequested = false
            })
        } else {
          this.$services.update('inscripcion', 'updateInscripcionEstado', { estado: +(!proyecto.inscripcion_activa) }, [proyecto.id_inscripcion])
            .then(response => {
              this.$alerts.pushAlert('mEditionAssetSignedStudents', 'updateInscripcionEstado', response.data.activo ? 'activationSuccess' : 'deactivationSuccess')
              this.search = ''
              this.searcheds = []
              this.readProyectos()
            })
            .catch(error => {
              console.log(error)
              this.$alerts.pushAlert('mEditionAssetSignedStudents', 'updateInscripcionEstado', 'error', 'a-alert-danger')
              this.requests.updateProductoProyectos.isRequested = false
            })
        }
      }
    }
  }
}
</script>
